// navigator.clipboard.writeText puede rechazar en silencio (documento sin foco, permiso
// denegado, contexto no seguro) — sin fallback el botón simplemente no hacía nada visible.
// Fallback: textarea oculto + execCommand('copy') (soportado incluso donde Clipboard API no
// aplica). Devuelve true si copió por cualquiera de las dos vías, false si ambas fallaron.
// (Extraído de src/partner/clipboard.ts para compartirlo con el panel; partner re-exporta.)
const copyTextFallback = (text: string): boolean => {
  try {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(textarea);
    return ok;
  } catch {
    return false;
  }
};

export const copyTextToClipboard = (text: string, onDone: (ok: boolean) => void) => {
  if (navigator.clipboard?.writeText) {
    navigator.clipboard.writeText(text).then(
      () => onDone(true),
      () => onDone(copyTextFallback(text)),
    );
  } else {
    onDone(copyTextFallback(text));
  }
};
